/*
 * Special View for handling the Topics and Topic pages, and switching between them without distroying each other
 */

define(["marionette", "jquery", "modules/topicsSplit/template/topicsSplitTemplate.html"], function (
  Marionette,
  $,
  TopicsSplitTemplate,
) {
  var TopicsSplitView = {};

  TopicsSplitView.topicsSplitLayout = Marionette.Layout.extend({
    template: TopicsSplitTemplate,
    regions: {
      topicsRegion: "#topicsRegion",
      topicRegion: "#topicRegion",
      miniLearner: "#miniLearner",
    },
    hideTopic: function () {
      $("#topicRegion").hide();
    },
    hideTopics: function () {
      $("#topicsRegion").hide();
    },
    showTopic: function () {
      $("#topicRegion").show();
    },
    showTopics: function () {
      $("#topicsRegion").show();
    },
  });

  return TopicsSplitView;
});
